<template>
  <!-- <div>
    <el-card shadow="never">
      <div class="side-frame">
        <span style="font-size: 14px; color: #606266">基本信息</span>
      </div>
      <edit-form
        ref="editForm"
        :disabled="isDisableEditForm"
        :params="params"
      />
      <div class="d-flex justify-content-end mb-2">
        <el-button
          v-if="!isDisableEditForm"
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
          >保存</el-button
        >
      </div>
    </el-card>
  </div> -->
  <b-container fluid>
    <el-page-header
      @back="() => $refs.editForm.goBack()"
      :title="$l('INDEX.btn_cancel') || '返回'"
      :content="pageHeader"
    />
    <b-row class="mt-2">
      <b-col>
        <b-card>
          <edit-form
            :disabled="isDisableEditForm"
            :params="params"
            ref="editForm"
          />
          <div class="d2-mt">
            <div class="d2-mt">
              <el-row>
                <el-col :span="20">
                  <el-button size="mini" @click="() => $refs.editForm.goBack()">
                    {{ $l('INDEX.btn_cancel') || '返回' }}
                  </el-button>
                  <el-button
                    v-if="!isDisableEditForm"
                    size="mini"
                    type="primary"
                    @click="() => $refs.editForm.save()"
                  >
                    {{ $l('INDEX.btn_save') || '保存' }}
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'master-customerSet-detail',
  components: {
    EditForm,
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    pageHeader() {
      const types = {
        add: this.$l('form_label_customer_add') || '添加客户档案',
        edit: this.$l('form_label_customer_edit') || '编辑客户档案',
        detail: this.$l('form_label_customer_detail') || '客户档案详情',
      }
      return types[this.pageType]
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {
    goBack() {},
    save() {
      this.$refs.editForm.save()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
